import { c as _c } from "react/compiler-runtime";
import { CreditPurchaseSuccess } from "@pages/settings/subscription-settings/credits/credit-purchase-success";
import { NewCreditBadge } from "@pages/settings/subscription-settings/credits/new-credit-badge";

/** Renders new credit indication for example success dialog */
export function NewCreditIndication() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><CreditPurchaseSuccess /><NewCreditBadge /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}